import { useAppSelector } from "@/shared/lib/redux"
import { ChartBlock } from "@/shared/ui/chart-block"
import { selectMonthlyStatistics } from "../../model"
import { useMemo } from "react"
import { monthNames } from "@/shared/consts/month-names"
import { ChartData } from "chart.js"

export const MonthlyRevenue = () => {
    const monthlyStatistics = useAppSelector(selectMonthlyStatistics)
    
    const data: ChartData<"line"> = useMemo(() => {
        const sortedData = [...monthlyStatistics].sort((a, b) => 
            new Date(a.date).getTime() - new Date(b.date).getTime()
        )

        const labels = sortedData.map(item => {
            const date = new Date(item.date)
            return `${monthNames[date.getMonth()]} ${date.getFullYear()}`
        })

        const data = sortedData.map(item => item.total)

        return {
            labels,
            datasets: [{
                fill: true,   
                borderColor: 'rgba(5, 205, 153, 0.8)',
                borderWidth: 2,
                backgroundColor: function(ctx) {
                    const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 400);
                    gradient.addColorStop(0.01, 'rgb(5, 205, 153,0.7)');
                    gradient.addColorStop(0.7, 'rgb(5, 205, 153,0.1)');
                    return gradient
                },
                data,
                tension: 0.4
            }]
        }
    }, [monthlyStatistics])
    
    return (
        <ChartBlock 
            type="line" 
            chartClass="min-h-[350px] screen:min-h-[450px] h-full" 
            title="Выручка за месяц" 
            data={data}
        />
    )
}